import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { SuperAdminService } from '../../services/super-admin/super-admin.service';
import { ToastService } from '../../services/toast/toast.service';
import { LoaderComponent } from '../../atoms/loader/loader.component';
import { SaAddRoleDialogComponent } from './sa-add-role-dialog/sa-add-role-dialog.component';
import { SaRoleViewsDialogComponent } from './sa-role-views-dialog/sa-role-views-dialog.component';

@Component({
  selector: 'app-sa-roles',
  standalone: true,
  imports: [CommonModule, LoaderComponent],
  templateUrl: './sa-roles.component.html',
  styleUrls: ['./sa-roles.component.scss', '../../../common-style/admin-list-page.scss'],
})
export class SaRolesComponent implements OnInit {
  roles: any[] = [];
  isLoading: boolean = false;

  constructor(
    private superAdminService: SuperAdminService,
    private toastService: ToastService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.isLoading = true;
    this.superAdminService.listRoles().subscribe({
      next: (res: any) => {
        this.roles = res?.data?.roles || [];
        this.isLoading = false;
      },
      error: (err) => {
        this.roles = [];
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to load roles.');
      },
    });
  }

  addRole(): void {
    const ref = this.dialog.open(SaAddRoleDialogComponent, {
      width: '640px',
      maxWidth: 'calc(100vw - 32px)',
      maxHeight: 'calc(100dvh - 32px)',
    });
    ref.afterClosed().subscribe((changed: boolean) => {
      if (changed) this.load();
    });
  }

  editRole(role: any): void {
    const ref = this.dialog.open(SaAddRoleDialogComponent, {
      width: '640px',
      maxWidth: 'calc(100vw - 32px)',
      maxHeight: 'calc(100dvh - 32px)',
      data: { role },
    });
    ref.afterClosed().subscribe((changed: boolean) => {
      if (changed) this.load();
    });
  }

  manageViews(role: any): void {
    this.dialog.open(SaRoleViewsDialogComponent, {
      width: '720px',
      maxWidth: 'calc(100vw - 32px)',
      maxHeight: 'calc(100dvh - 32px)',
      data: { roleId: role.roleId, roleName: role.roleName },
    });
  }
}